import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useSession } from './SessionContext';

const CreditContext = createContext(null);

export const useCredit = () => {
  const ctx = useContext(CreditContext);
  if (!ctx) throw new Error('useCredit must be used within CreditProvider');
  return ctx;
};

export const CreditProvider = ({ children }) => {
  const { isAuthenticated } = useSession();
  const [balance, setBalance] = useState({ subscription: 0, activity: 0, total: 0 });
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!isAuthenticated) {
      setBalance({ subscription: 0, activity: 0, total: 0 });
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/credits', { credentials: 'include' });
      if (res.ok) {
        const data = await res.json();
        if (data.success) setBalance(data.balance);
      }
    } catch {
      // 크레딧 조회 실패는 조용히 처리
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <CreditContext.Provider value={{ balance, loading, refresh }}>
      {children}
    </CreditContext.Provider>
  );
};
